import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faq';

export default function FaqTeaser() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div>
          <span className="flex items-center gap-2 text-sm font-semibold text-secondary-700">
            <i className="ri-question-line text-base" />
            读者答疑
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">韩漫选漫常见问题</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            从榜单解读到入坑建议，帮你快速上手、不再书荒。更多问题欢迎前往完整答疑页，或通过邮箱与我们交流。
          </p>
          <Link to="/faq" className="mt-5 inline-flex items-center gap-2 rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600">
            查看全部常见问题
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="flex flex-col gap-4">
          {faqs.slice(0, 3).map((f) => (
            <details key={f.question} className="group rounded-lg border border-background-200 bg-background-50 p-5">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3">
                <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">{f.question}</h3>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform group-open:rotate-45">
                  <i className="ri-add-line text-sm" />
                </span>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}